import React, { Component } from 'react'
import Gallery from '../../../shared/components/Gallery'
// import HelpText from '../../../shared/components/HelpText'
import { connect } from 'react-redux'
// import styles
import './evaluation.scss'

// Constants
import {
  // API_URL,
  FILE_STORAGE
} from '../../../constants'

// Actions
import {
  getDocPhoto,
  getDocEvaluations
} from '../../../actions/documentation'
import {
  getRejectedEvaluations
} from '../../../actions/orders'

// Utils
import { renderFullDate } from '../../../utils/time'
import { translation } from '../../../utils/helpers'
import { formatArrayToString } from '../../../utils/array'

import Part from '../Extent/Part'
// Elements
import PanelHeader from '../../elements/panelHeader'
import LabelWrapper from '../../elements/labelWrapper'
import Divider from '../../elements/divider'
import UserInfo from '../UserInfo'

class Evaluation extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,
      evaluation: props.evaluation,
      rejections: []
    }
    this.renderEvaluation = this.renderEvaluation.bind(this)
    this.renderRejectedImages = this.renderRejectedImages.bind(this)
    this.getRejections = this.getRejections.bind(this)
    this.getDocEvaluations = this.getDocEvaluations.bind(this)
  }

  componentDidMount () {
    this.getRejections(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.orderId !== nextProps.orderId) {
      this.getRejections(nextProps)
    }
  }

  getDocEvaluations (orderId) {
    return this.props.getDocEvaluations(orderId).then((res) => {
      this.setState({
        evaluation: res.data.Estimation
      })
      return res
    })
  }
  getRejections (props) {
    if (props.orderId !== undefined && props.orderId > 0) {
      this.setState({
        isLoading: true
      }, () => {
        if (props.evaluation === undefined || props.evaluation === null) {
          this.getDocEvaluations(props.orderId)
        } else {
          this.setState({
            evaluation: props.evaluation
          })
        }
        this.props.getRejectedEvaluations(props.orderId).then((res) => {
          let data = res.data
          this.setState({
            rejections: data
          }, () => {
            this.setState({
              isLoading: false
            }, () => {
              if (this.state.rejections !== undefined && this.state.rejecions !== null && this.state.rejections.length > 0) {
                let lastIndex = this.state.rejections.length - 1
                let lastCreationInfo = this.state.rejections[lastIndex].CreationInfo
                if (lastCreationInfo.Comment !== null && this.props.setEstimationComment !== undefined) {
                  this.props.setEstimationComment(lastCreationInfo.Comment)
                }
              }
            })
            // console.log('success', this.state)
          })
        }, () => {
          this.setState({
            isLoading: false
          })
          console.log('failed')
        })
      })
    }
  }
  renderRejectedImages (rejectedImages) {
    const renderRejectedImage = (image, index) => {
      let url = FILE_STORAGE + image.ThumbURL
      let fullUrl = FILE_STORAGE + image.FileURL
      return (
        <div key={index} className='file-image'>
          <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
        </div>
      )
    }
    // Return
    return (
      <div className='estimation_images'>
        <Gallery files={rejectedImages} renderImage={renderRejectedImage} />
      </div>
    )
  }
  renderEvaluation () {
    const renderRejections = () => {
      return (
        <div className='clearfix estimation__comment'>
          {this.state.rejections.map(renderRejection)}
        </div>
      )
    }
    const renderRejection = (val, index) => {
      let creationInfo = val.CreationInfo
      let rejectionInfo = val.RejectionInfo
      let images = val.Images

      return (
        <div key={index}>
          <div>
            <PanelHeader text={translation('13035')} />

            <div>{formatArrayToString(creationInfo.Comment)}</div>
            {images !== null && this.renderRejectedImages(images)}

            <Divider noLine />

            <LabelWrapper labelText={translation('13387')}>
              {renderFullDate(creationInfo.Date)}
            </LabelWrapper>
            <LabelWrapper labelText={translation('263')}>
              <UserInfo user={creationInfo.UserInfo} />
            </LabelWrapper>

            <div>{creationInfo.Company}</div>
          </div>

          <Divider />

          <div>
            <PanelHeader text={translation('13714')} />

            <div>{formatArrayToString(rejectionInfo.Comment)}</div>
            <Divider noLine />

            <LabelWrapper labelText={translation('372')}>
              {renderFullDate(rejectionInfo.Date)}
            </LabelWrapper>
            <LabelWrapper labelText={translation('763')}>
              <UserInfo user={rejectionInfo.UserInfo} />
            </LabelWrapper>

            <div>{rejectionInfo.Company}</div>

            <Divider />
          </div>
        </div>
      )
    }
    let evaluation = this.state.evaluation
    const renderTop = (evaluation) => {
      let noEvaluation = evaluation === undefined || evaluation === null || (evaluation.InitialCreationTime === null && evaluation.CompletedTime === null) || (evaluation.InitialCreationTime === null && evaluation.CompletedTime !== null)
      if (noEvaluation) {
        return null
        // return (
        //   <div>
        //     {translation('13534')}
        //   </div>
        // )
      }
      if (this.props.noCompleted) return null
      let comment = evaluation.InitialComment
      let date = evaluation.InitialCreationTime
      let customerName = evaluation.InitialCustomerName
      let photos = evaluation.InitialPhotos
      // let photos = evaluation.Photos
      let mail = evaluation.InitialUserMail !== undefined ? evaluation.InitialUserMail : ''
      let phone = evaluation.InitialUserPhone !== undefined ? evaluation.InitialUserPhone : ''

      let hasMailOrPhone = mail !== null && mail.length > 0 || phone !== null && phone.length > 0
      const renderImage = (item, key) => {
        let url = FILE_STORAGE + item.ThumbURL
        let fullUrl = FILE_STORAGE + item.FileURL
        return (
          <div key={key}>
            <a href={fullUrl} data-lightbox='gallery' data-title={item.FileName}><img src={url} /></a>
          </div>
        )
      }

      return (
        <div>
          <PanelHeader text={translation('13035')} />

          {comment && <div>{comment}</div>}
          {photos !== null && photos.length > 0 && (
            <Gallery renderImage={renderImage} files={photos} />
          )}

          <Divider noLine />

          <LabelWrapper labelText={translation('13387')}>
            {renderFullDate(date)}
          </LabelWrapper>
          <LabelWrapper labelText={translation('263')} helpText={hasMailOrPhone && mail + '\n' + phone}>
            <UserInfo user={evaluation.InitialUserInfo} />
          </LabelWrapper>

          <div>{customerName}</div>

          <Divider />
        </div>
      )
    }

    const renderCompletedInfo = (evaluation) => {
      if (evaluation === undefined || evaluation === null || evaluation.CompletedTime === null || this.props.noCompleted) {
        return null
      }
      let date = evaluation.CompletedTime
      // let shopName = evaluation.CompletedByUserName + ' (' + evaluation.CompletedByCompanyName + ')'
      return (
        <div>
          <LabelWrapper labelText={translation('372')}>
            {renderFullDate(date)}
          </LabelWrapper>
          <LabelWrapper labelText={translation('763')} helpText={(evaluation.CompletedByUserMail.length > 0 || evaluation.CompletedByUserPhone.length > 0) && evaluation.CompletedByUserMail + '\n' + evaluation.CompletedByUserPhone}>
            <UserInfo user={evaluation.CompletedByUserInfo} />
          </LabelWrapper>
        </div>
      )
    }

    const renderBottom = (evaluation) => {
      if (evaluation === undefined || evaluation === null || this.props.isEdit || (!this.props.isEdit && (evaluation.EvaluationId === null || evaluation.EvaluationId === 0))) return null
      let parts = evaluation.Parts
      const refinishTypes = evaluation.RefinishTypes
      const startTimes = evaluation.StartTimes
      const hourPrices = evaluation.HourPrices
      const materialsShares = evaluation.MaterialsShares
      let photos = evaluation.Photos
      let comment = ''
      if (evaluation.Comment !== null && evaluation.Comment.Note !== null) {
        comment = evaluation.Comment.Note
      }

      const renderPart = (val, key) => {
        // let partDict = val.Part.DictionaryKey
        // let tasks = val.EstimationTasks
        // let taskSide = val.Part.TaskSide

        // // Set text for side
        // switch (taskSide) {
        //   case 0:
        //     taskSide = '' // none
        //     break
        //   case 1:
        //     taskSide = translation('213') // left
        //     break
        //   case 2:
        //     taskSide = translation('214') // right
        //     break
        //   case 3:
        //     taskSide = translation('287') // front
        //     break
        //   case 4:
        //     taskSide = translation('288') // back
        //     break
        //   case 5:
        //     taskSide = translation('213') + ' ' + translation('287') // left front
        //     break
        //   case 6:
        //     taskSide = translation('214') + ' ' + translation('287') // right front
        //     break
        //   case 7:
        //     taskSide = translation('213') + ' ' + translation('288') // left back
        //     break
        //   case 8:
        //     taskSide = translation('214') + ' ' + translation('288') // right back
        //     break
        // }

        // const renderTask = (val, key) => {
        //   let taskName = val.TaskName
        //   let extent = val.Extent
        //   let extentType = extent !== null ? extent.Type : ''
        //   let extras = val.Extras

        //   const renderTaskExtra = (val, key) => {
        //     let extraName = val.Name
        //     let extraAe = val.AE
        //     let extraMat = val.Material
        //     return (
        //       <div className='taskExtra' key={'extra_' + key}>{extraName} ({extraAe} {translation('885')}, {extraMat} {translation('13443')})</div>
        //     )
        //   }

        //   return (
        //     <div className='taskEntry' key={'task_' + key}>
        //       <div>{taskName} {extentType}</div>
        //       <div>
        //         {extras.map(renderTaskExtra)}
        //       </div>
        //     </div>
        //   )
        // }

        return (
          <div className='extent-content' key={key}>
            <Part part={val} />
          </div>
        )
        // return (
        //   <div key={'part_' + key}>
        //     <h3>{translation(partDict)} {taskSide}</h3>
        //     <div className='taskBox'>
        //       {tasks.map(renderTask)}
        //     </div>
        //   </div>
        // )
      }

      const renderEstimationTypes = (titleCode, estimationTypes) => {
        if (!estimationTypes || estimationTypes.length === 0) return null

        return (
          <LabelWrapper labelText={translation(titleCode)}>
            {estimationTypes.map((type, key) => <div key={key}>{type}</div>)}
          </LabelWrapper>
        )
      }

      const renderImage = (item, key) => {
        let url = FILE_STORAGE + item.ThumbURL
        let fullUrl = FILE_STORAGE + item.FileURL
        return (
          <div key={key}>
            <a href={fullUrl} data-lightbox='gallery' data-title={item.FileName}><img src={url} /></a>
          </div>
        )
      }

      let hideParts = this.props.noParts
      return (
        <div>
          {evaluation.CompletedTime !== null && (
            <PanelHeader text={translation('14944')} />
          )}

          {!hideParts && <div>{parts.map(renderPart)}</div>}
          {!hideParts && renderEstimationTypes('161', refinishTypes)}
          {!hideParts && renderEstimationTypes('1195', startTimes)}
          {!hideParts && renderEstimationTypes('419', hourPrices)}
          {!hideParts && renderEstimationTypes('415', materialsShares)}

          {photos !== null && photos.length > 0 && [
            <Gallery renderImage={renderImage} files={photos} key='gallery' />,
            <Divider noLine key='divider' />
          ]}

          {comment !== '' && [
            <div key='comment'>{formatArrayToString(comment)}</div>,
            <Divider noLine key='divider' />
          ]}
        </div>
      )
    }
    const loadingSpinner = () => {
      return (
        <div className='animated-background'>
          <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
          <span className='sr-only'>{translation('13382')}...</span>
        </div>
      )
    }
    if (this.state.isLoading) {
      return (
        <div>
          {loadingSpinner()}
        </div>)
    }
    return (
      <div>
        {renderRejections()}
        {renderTop(evaluation)}
        {renderBottom(evaluation)}
        {renderCompletedInfo(evaluation)}
      </div>
    )
  }
  render () {
    return (
      <div className='evaluations__screen'>
        {this.renderEvaluation()}
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    order: state.orders.order
  }
}

export default connect(mapStateToProps, {
  getDocPhoto,
  getDocEvaluations,
  getRejectedEvaluations
})(Evaluation)



// WEBPACK FOOTER //
// ./src/app/shared/components/Evaluation/index.js